import * as v from 'valibot';

import { maoAircraftSchema } from './maoAircraft.schema';

import type { MaoMovement } from '../types';

export const maoMovementSchema: v.GenericSchema<MaoMovement> = v.object({
  Aircraft: v.pick(maoAircraftSchema, ['Registration', 'Id']),
  ScheduledOffBlocksUtc: v.string('Scheduled off blocks UTC is missing'),
  ScheduledOffBlocksUtcUnix: v.number(
    'Scheduled off blocks UTC unix is missing',
  ),
  ScheduledOnBlocksUtc: v.string('Scheduled on blocks UTC is missing'),
  ScheduledOnBlocksUtcUnix: v.number('Scheduled on blocks UTC unix is missing'),
  IsOffBlocks: v.boolean('Off blocks status is missing'),
  IsOnBlocks: v.boolean('On blocks status is missing'),
});
